import styled from 'styled-components';

export const Footer = styled.div`
  border-top: 1px solid var(--color-border);
  margin-top: 20px;
  padding-top: 20px;
  text-align: right;
`;
